import { FunnelIcon } from '@heroicons/react/24/outline';
//@ts-ignore: Missing types in `beautiful-react-hooks`
import useDebouncedCallback from 'beautiful-react-hooks/useDebouncedCallback';
import { useEffect, useState } from 'react';

import { Input } from '@/components/core/Input';
import { useTranslation } from '@/hooks/useTranslation';

import { BulkSubscription } from '../bulk-subscriptions.types';
import { DeleteAllEntriesConfirmationDialog } from './DeleteAllEntriesConfirmationDialog';

interface EntriesToolbarProps {
    entity: BulkSubscription;
    textFilter?: string;
    onTextFilterChange: (newValue: string) => void;
    refetchData: () => void;
}

const EntriesToolbar = ({
    entity,
    textFilter,
    onTextFilterChange,
    refetchData
}: EntriesToolbarProps ) => {

    const [isDeleteConfirmationDialogOpen, setIsDeleteConfirmationDialogOpen] = useState(false);

    const { t } = useTranslation();
    const [ internalTextFilter, setInternalTextFilter ] = useState<string | undefined>(textFilter);
    const debouncedOnTextFilterChange = useDebouncedCallback(onTextFilterChange);

    useEffect(() => {
        debouncedOnTextFilterChange(internalTextFilter);
    }, [internalTextFilter, debouncedOnTextFilterChange]);

    useEffect(() => {
        setInternalTextFilter(textFilter);
    }, [textFilter]);

    const onDeleteClose = (shouldRefetchData?: boolean) => {
        if (shouldRefetchData) {
            refetchData();
        }

        setIsDeleteConfirmationDialogOpen(false);
    };

    return (
        <div className="tw-flex tw-flex-col tw-w-full">
            <Input
                className="tw-flex-none tw-w-full"
                placeholder={t('BULK_SUBSCRIPTION.SEARCH_ENTRIES')}
                title={t('BULK_SUBSCRIPTION.SEARCH_ENTRIES')}
                icon={FunnelIcon}
                value={internalTextFilter}
                onChange={(event) => setInternalTextFilter(event.target.value)}
            />
            {
                isDeleteConfirmationDialogOpen &&
                <DeleteAllEntriesConfirmationDialog
                    entity={entity}
                    open={isDeleteConfirmationDialogOpen}
                    onClose={onDeleteClose}
                />
            }
        </div>
    );
};

export { EntriesToolbar };
